import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";

export default function SpringBtn({ className, tooltip, ...props }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  useEffect(() => {
    if (showTooltip && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top + window.scrollY,
        left: rect.left + rect.width / 2 + window.scrollX,
      });
    }
  }, [showTooltip]);

  return (
    <>
      <motion.button
        ref={buttonRef}
        disabled={props.disable}
        className={`disabled:opacity-50 disabled:cursor-default ${className}`}
        whileTap={props.disabled ? "" : { scale: 0.8 }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        {...props}
      />
      {tooltip && showTooltip && createPortal(
        <div 
          className="fixed px-3 py-1.5 bg-gray-900 text-white text-sm rounded-lg pointer-events-none whitespace-nowrap"
          style={{
            top: `${tooltipPosition.top - 40}px`,
            left: `${tooltipPosition.left}px`,
            transform: 'translateX(-50%)',
            zIndex: 9999,
          }}
        >
          {tooltip}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1 border-4 border-transparent border-t-gray-900"></div>
        </div>,
        document.body
      )}
    </>
  );
}
